import { W as WuiRadioButton$1, d as defineCustomElement$1 } from './p-Cq913ncI.js';

const WuiRadioButton = WuiRadioButton$1;
const defineCustomElement = defineCustomElement$1;

export { WuiRadioButton, defineCustomElement };
